import { useContext } from 'react';
import { ExpandedContext } from '../context/expanded-context';

export const useExpandedContext = () => {
	const context = useContext(ExpandedContext);

	if (!context) {
		throw new Error('useExpandedContext must be used within an ExpandedContextProvider');
	}

	return context;
};
